module.exports = __webpack_public_path__ + "b9d7b89a872d5fd85073330e034c5596.png";